import { apiClient } from '@/lib/api-client';
import type { AdminApiTokenList } from '@/types/api';

/**
 * Staff-only view of every API token.
 *
 * Read and revoke. There is no create, deliberately — see AdminApiTokenController for why
 * impersonation covers that case better than a long-lived cross-tenant credential would.
 */
export const adminApiTokensApi = {
  list: (filters: { search?: string; status?: string } = {}) => {
    const query = new URLSearchParams();

    if (filters.search) {
      query.set('search', filters.search);
    }

    if (filters.status) {
      query.set('status', filters.status);
    }

    const suffix = query.toString();

    return apiClient.get<AdminApiTokenList>(
      suffix === '' ? '/admin/api-tokens' : `/admin/api-tokens?${suffix}`,
    );
  },

  revoke: (id: string) => apiClient.delete<{ revoked: boolean }>(`/admin/api-tokens/${id}`),
};
